/**
 * 产品选购推荐 + 对比工具
 * 路径 A（quiz）：问卷筛选 → 产品网格勾选 → 对比
 * 路径 B（browse）：Keychron 风格下拉选择器 → 卡片 → 参数表格
 */
(function () {
  'use strict';

  /* ── 配置 ── */
  const CFG = JSON.parse(
    document.querySelector('[data-compare-config]')?.textContent || '{}'
  );
  if (!CFG.shopUrl) return;


  /* ── 状态 ── */
  const S = {
    mode: 'browse',
    category: '',
    products: {},
    seriesMap: {},
    checked: [],
    filtered: null,
    quiz: { step: 0, answers: {}, questions: [] },
    slots: { 1: null, 2: null, 3: null, 4: null },
    diffOn: false,
    slotDiffOn: false,
    priceFilter: 'all',
    productPage: 1,
    autoCompareApplied: false,
  };

  const PRODUCT_PAGE_ROWS = 3;

  /* ── DOM 缓存 ── */
  const $ = (sel, ctx) => (ctx || document).querySelector(sel);
  const $$ = (sel, ctx) => [...(ctx || document).querySelectorAll(sel)];

  /* ── 可搜索下拉组件 ── */
  function createCombo(selectEl) {
    const wrap = selectEl.closest('.pc-slot__select-wrap');
    if (!wrap || wrap.querySelector('.pc-combo')) return wrap?.querySelector('.pc-combo');

    const combo = document.createElement('div');
    combo.className = 'pc-combo' + (selectEl.disabled ? ' is-disabled' : '');

    const input = document.createElement('input');
    input.type = 'text';
    input.className = 'pc-combo__input';
    input.placeholder = selectEl.options[0]?.text || 'Select...';
    input.readOnly = false;
    input.autocomplete = 'off';

    const clearBtn = document.createElement('button');
    clearBtn.type = 'button';
    clearBtn.className = 'pc-combo__clear';
    clearBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M10.5 3.5L3.5 10.5M3.5 3.5l7 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
    clearBtn.style.display = 'none';

    const list = document.createElement('div');
    list.className = 'pc-combo__list';

    combo.appendChild(input);
    combo.appendChild(clearBtn);
    combo.appendChild(list);
    wrap.insertBefore(combo, selectEl);

    let items = [];
    let focusIdx = -1;

    function updateClearBtn() {
      const arrow = wrap.querySelector('.pc-slot__arrow');
      if (input.value && !selectEl.disabled) {
        clearBtn.style.display = '';
        if (arrow) arrow.style.display = 'none';
      } else {
        clearBtn.style.display = 'none';
        if (arrow) arrow.style.display = '';
      }
    }

    function syncFromSelect() {
      items = [];
      list.innerHTML = '';
      for (let i = 1; i < selectEl.options.length; i++) {
        const o = selectEl.options[i];
        items.push({ value: o.value, text: o.textContent });
      }
      combo.classList.toggle('is-disabled', selectEl.disabled);
      if (selectEl.disabled) {
        input.value = '';
        input.placeholder = selectEl.options[0]?.text || 'Select...';
      }
      if (selectEl.value) {
        const sel = items.find((it) => it.value === selectEl.value);
        if (sel) input.value = sel.text;
      } else {
        input.value = '';
      }
      updateClearBtn();
    }

    function render(query) {
      list.innerHTML = '';
      focusIdx = -1;
      const q = (query || '').toLowerCase().trim();
      const filtered = q ? items.filter((it) => it.text.toLowerCase().includes(q)) : items;
      if (!filtered.length) {
        list.innerHTML = '<div class="pc-combo__empty">No results</div>';
        return;
      }
      filtered.forEach((it, i) => {
        const div = document.createElement('div');
        div.className = 'pc-combo__item' + (it.value === selectEl.value ? ' is-selected' : '');
        div.dataset.value = it.value;
        if (q) {
          const idx = it.text.toLowerCase().indexOf(q);
          div.innerHTML = it.text.slice(0, idx) + '<mark>' + it.text.slice(idx, idx + q.length) + '</mark>' + it.text.slice(idx + q.length);
        } else {
          div.textContent = it.text;
        }
        div.addEventListener('mousedown', (e) => {
          e.preventDefault();
          pick(it);
        });
        list.appendChild(div);
      });
    }

    function pick(it) {
      selectEl.value = it.value;
      input.value = it.text;
      close();
      updateClearBtn();
      selectEl.dispatchEvent(new Event('change', { bubbles: true }));
    }

    clearBtn.addEventListener('mousedown', (e) => {
      e.preventDefault();
      selectEl.value = '';
      input.value = '';
      updateClearBtn();
      selectEl.dispatchEvent(new Event('change', { bubbles: true }));
      input.focus();
      open();
    });

    function open(query) {
      if (selectEl.disabled) return;
      combo.classList.add('is-open');
      render(query === undefined ? input.value : query);
    }

    function close() {
      combo.classList.remove('is-open');
      focusIdx = -1;
    }

    input.addEventListener('focus', () => {
      input.select();
      open('');
    });
    input.addEventListener('input', () => {
      open();
      render(input.value);
      updateClearBtn();
    });
    input.addEventListener('blur', () => {
      setTimeout(close, 150);
    });
    input.addEventListener('keydown', (e) => {
      const listItems = list.querySelectorAll('.pc-combo__item');
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        focusIdx = Math.min(focusIdx + 1, listItems.length - 1);
        listItems.forEach((el, i) => el.classList.toggle('is-focused', i === focusIdx));
        if (listItems[focusIdx]) listItems[focusIdx].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        focusIdx = Math.max(focusIdx - 1, 0);
        listItems.forEach((el, i) => el.classList.toggle('is-focused', i === focusIdx));
        if (listItems[focusIdx]) listItems[focusIdx].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter') {
        e.preventDefault();
        if (focusIdx >= 0 && listItems[focusIdx]) {
          const val = listItems[focusIdx].dataset.value;
          const it = items.find((x) => x.value === val);
          if (it) pick(it);
        }
      } else if (e.key === 'Escape') {
        close();
        input.blur();
      }
    });

    syncFromSelect();
    combo._sync = syncFromSelect;
    return combo;
  }

  function syncAllCombos() {
    $$('.pc-slot__select').forEach((sel) => {
      const wrap = sel.closest('.pc-slot__select-wrap');
      const combo = wrap?.querySelector('.pc-combo');
      if (combo && combo._sync) combo._sync();
    });
  }

  /* ── 工具函数 ── */
  const stripHtml = (s) => {
    const d = document.createElement('div');
    d.innerHTML = s;
    return d.textContent || d.innerText || s;
  };

  /**
   * Shopify AJAX API 返回价格为字符串（如 "59.98"），单位是美元，不是分
   */
  const money = (raw) => {
    if (raw == null || raw === '') return '';
    const num = typeof raw === 'string' ? parseFloat(raw) : raw;
    if (isNaN(num)) return '';
    const fmt = CFG.moneyFormat || '${{amount}}';
    const result = fmt
      .replace('{{amount}}', num.toFixed(2))
      .replace('{{amount_no_decimals}}', Math.round(num))
      .replace('{{amount_with_comma_separator}}', num.toFixed(2).replace('.', ','))
      .replace('{{amount_with_apostrophe_separator}}', num.toFixed(2).replace('.', "'"));
    return stripHtml(result);
  };

  /**
   * 解析 Shopify Rich Text metafield JSON，提取 Key: Value 键值对
   * 支持 paragraph、list（ordered/unordered）、listItem 等多种结构
   * 每个叶子文本块视为一行，用正则提取 "Key: Value" 或 "Key：Value"
   * @returns {{ [normalizedKey: string]: { label: string, value: string } }}
   */
  function parseRichTextSpecs(raw) {
    const result = {};
    if (!raw) return result;

    let obj = raw;
    if (typeof raw === 'string') {
      try { obj = JSON.parse(raw); } catch (_) { return result; }
    }

    if (!obj || !obj.children) return result;

    const extractText = (node) => {
      if (!node) return '';
      if (node.value) return node.value;
      if (node.children) return node.children.map(extractText).join('');
      return '';
    };

    /**
     * 递归收集所有"叶子行"：paragraph 和 listItem 各算一行
     */
    const collectLines = (node) => {
      if (!node) return [];
      const lines = [];
      const t = node.type;
      if (t === 'paragraph' || t === 'listItem' || t === 'list-item') {
        const text = extractText(node).trim();
        if (text) lines.push(text);
      } else if (node.children) {
        for (const c of node.children) {
          lines.push(...collectLines(c));
        }
      }
      return lines;
    };

    const allLines = collectLines(obj);
    for (const line of allLines) {
      const m = line.match(/^(.+?)\s*[:：]\s*(.+)$/);
      if (m) {
        const originalLabel = m[1].trim();
        const k = originalLabel.toLowerCase().replace(/\s+/g, '_');
        result[k] = { label: originalLabel, value: m[2].trim() };
      }
    }
    return result;
  }

  /**
   * 初始化时解析 CFG.variantSpecs，构建缓存
   * S.variantSpecsCache: { productId: { variantId: { key: value } } }
   */
  function parseVariantSpecs() {
    S.variantSpecsCache = {};
    const vs = CFG.variantSpecs;
    if (!vs) return;
    for (const pid in vs) {
      S.variantSpecsCache[pid] = {};
      for (const vid in vs[pid]) {
        S.variantSpecsCache[pid][vid] = parseRichTextSpecs(vs[pid][vid]);
      }
    }
  }

  function variantHasSpecs(product, variantId) {
    if (!CFG.hideProductsWithoutSpecs) return true;
    const specs = S.variantSpecsCache?.[String(product.id)]?.[String(variantId)];
    return !!(specs && Object.keys(specs).length);
  }

  function productHasSpecs(product) {
    if (!CFG.hideProductsWithoutSpecs) return true;
    const productSpecs = S.variantSpecsCache?.[String(product.id)];
    if (!productSpecs) return false;
    return Object.values(productSpecs).some((specs) => specs && Object.keys(specs).length);
  }

  function getComparableVariants(product) {
    return (product.variants || []).filter((variant) => variantHasSpecs(product, variant.id));
  }

  /**
   * 获取产品规格值，三级回退：
   * 1. 指定 variant 的 metafield specs
   * 2. 产品下任意 variant 的 metafield specs（取第一个有值的）
   * 3. 产品 tags 匹配
   * @param {object} product - 产品对象
   * @param {string} key - spec key（小写下划线格式，如 weight）
   * @param {string|number} [variantId] - 可选，指定 variant ID
   * @returns {string} 规格值，无数据返回空字符串
   */
  const tagVal = (product, key, variantId) => {
    const pid = String(product.id);
    const k = key.toLowerCase().replace(/\s+/g, '_');
    const productSpecs = S.variantSpecsCache?.[pid];

    if (productSpecs) {
      if (variantId) {
        const vSpecs = productSpecs[String(variantId)];
        if (vSpecs?.[k]) return vSpecs[k].value;
      }
      for (const vid in productSpecs) {
        if (productSpecs[vid][k]) return productSpecs[vid][k].value;
      }
    }

    const prefix = key + '_';
    const tag = (product.tags || []).find((t) => t.startsWith(prefix));
    return tag ? tag.slice(prefix.length).replace(/_/g, ' ') : '';
  };

  /**
   * 从所有参与对比的产品中，收集 metafield 里出现过的所有 spec key
   * 返回去重且保持首次出现顺序的数组 [{ key, label }]
   */
  function collectSpecKeys(products, variantIds) {
    const seen = {};
    const keys = [];
    products.forEach((p, i) => {
      const pid = String(p.id);
      const productSpecs = S.variantSpecsCache?.[pid];
      if (!productSpecs) return;
      const vid = variantIds?.[i] ? String(variantIds[i]) : Object.keys(productSpecs)[0];
      const specs = productSpecs[vid] || {};
      for (const k in specs) {
        if (!seen[k]) {
          seen[k] = true;
          keys.push({ key: k, label: specs[k].label });
        }
      }
    });
    return keys;
  }

  const imgSrc = (src, size) =>
    src ? src.replace(/(\.\w+)(\?|$)/, `_${size}$1$2`) : '';

  /* ── 数据获取（带重试） ── */
  const fetchCache = {};

  async function fetchJson(url, retries) {
    for (let i = 0; i <= (retries || 2); i++) {
      try {
        const r = await fetch(url);
        if (r.ok) return await r.json();
      } catch (_) { /* 网络错误，重试 */ }
      if (i < (retries || 2)) await new Promise((r) => setTimeout(r, 800 * (i + 1)));
    }
    return null;
  }

  async function fetchCollection(handle) {
    if (fetchCache[handle]?.length) return fetchCache[handle];
    const all = [];
    let page = 1;
    while (true) {
      const d = await fetchJson(
        `${CFG.shopUrl}/collections/${handle}/products.json?limit=250&page=${page}`, 2
      );
      if (!d || !d.products || !d.products.length) break;
      all.push(...d.products);
      if (d.products.length < 250) break;
      page++;
    }
    if (all.length) fetchCache[handle] = all;
    return all;
  }

  /**
   * 加载当前分类下所有系列的产品
   * 同时构建 seriesMap：{ seriesHandle: { title, products[] } }
   */
  async function loadCategoryProducts(cat) {
    const catLower = cat.toLowerCase().trim();
    const series = (CFG.seriesCollections || []).filter(
      (s) => (s.category || '').toLowerCase().trim() === catLower
    );
    if (!series.length) {
      console.warn('[ProductCompare] No series found for category "' + cat + '". Available:', (CFG.seriesCollections || []).map(s => s.category));
    }

    /* 如果已有数据且不为空，直接返回 */
    if (S.products[cat]?.length && Object.keys(S.seriesMap[cat] || {}).length) {
      return S.products[cat];
    }

    S.products[cat] = [];
    S.seriesMap[cat] = {};

    if (series.length) {
      const results = await Promise.all(
        series.map((s) => fetchCollection(s.handle))
      );
      const seenIds = new Set();
      series.forEach((s, i) => {
        if (results[i]?.length) {
          const comparableProducts = results[i].filter(productHasSpecs);
          S.seriesMap[cat][s.handle] = { title: s.title, products: comparableProducts };
          comparableProducts.forEach((p) => {
            if (!seenIds.has(p.id)) {
              seenIds.add(p.id);
              S.products[cat].push(p);
            }
          });
        }
      });
    }
    return S.products[cat];
  }

  /* ============================================================
     初始化
     ============================================================ */

  function init() {
    if (!CFG.categories || !CFG.categories.length) return;
    parseVariantSpecs();
    S.category = CFG.categories[0].handle;
    initTabs();
    initModes();
    initQuizNav();
    initPriceFilter();
    initSelectionSummary();
    initCompareBar();
    initBackButton();
    initSlotEvents();
    switchCategory(S.category);
  }

  /* ── 分类 Tab ── */
  function initTabs() {
    const tabs = $$('[data-category-tab]');
    tabs.forEach((btn) => {
      btn.addEventListener('click', () => {
        tabs.forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        switchCategory(btn.dataset.categoryTab);
      });
    });
    /* 默认高亮第一个 tab */
    if (tabs.length) {
      tabs.forEach((b) => b.classList.remove('is-active'));
      tabs[0].classList.add('is-active');
    }
  }

  async function switchCategory(handle) {
    S.category = handle;
    S.checked = [];
    S.filtered = null;
    S.filteredSkus = null;
    S.priceFilter = 'all';
    S.productPage = 1;
    S.quiz = { step: 0, answers: {}, questions: getQuizQuestions(handle) };
    resetSlots();
    showLoading();
    await loadCategoryProducts(handle);
    const params = new URLSearchParams(window.location.search);
    const autoHandle = (params.get('product') || '').trim().toLowerCase();
    if (params.get('compare') === 'models' && autoHandle) {
      const currentHasProduct = (S.products[handle] || []).some(
        (item) => String(item.handle || '').toLowerCase() === autoHandle
      );
      if (!currentHasProduct) {
        for (const category of CFG.categories) {
          if (category.handle === handle) continue;
          await loadCategoryProducts(category.handle);
          const found = (S.products[category.handle] || []).some(
            (item) => String(item.handle || '').toLowerCase() === autoHandle
          );
          if (found) {
            S.category = category.handle;
            S.quiz.questions = getQuizQuestions(S.category);
            $$('[data-category-tab]').forEach((tab) => {
              tab.classList.toggle('is-active', tab.dataset.categoryTab === S.category);
            });
            resetSlots();
            break;
          }
        }
      }
    }
    hideLoading();
    const autoCompared = !S.autoCompareApplied && applyAutoCompareFromUrl();
    if (!autoCompared) setMode(S.mode);
  }

  function applyAutoCompareFromUrl() {
    const params = new URLSearchParams(window.location.search);
    let productHandle = (params.get('product') || params.get('handle') || params.get('product_handle') || '').trim().toLowerCase();
    const productId = params.get('product_id');

    if (!productHandle && document.referrer) {
      try {
        const referrer = new URL(document.referrer);
        const productMatch = referrer.pathname.match(/\/products\/([^/]+)/i);
        if (productMatch) productHandle = productMatch[1].toLowerCase();
      } catch (_) { /* Ignore malformed referrer URLs. */ }
    }

    if (!productHandle && !productId) return false;
    const product = (S.products[S.category] || []).find(
      (item) => (productHandle && String(item.handle || '').toLowerCase() === productHandle) ||
        (productId && String(item.id) === String(productId))
    );
    if (!product) return false;

    const modelIndex = (product.options || []).findIndex((option) =>
      /model|edition|version/i.test(option.name || '')
    );
    const colorIndex = (product.options || []).findIndex((option) =>
      /color|colour/i.test(option.name || '')
    );
    const groups = new Map();
    (product.variants || []).forEach((variant) => {
      if (variant.available === false || !variantHasSpecs(product, variant.id)) return;
      const values = variant.options || [variant.option1, variant.option2, variant.option3];
      const model = String(values[modelIndex >= 0 ? modelIndex : 0] || variant.title || '').trim();
      const color = String(values[colorIndex >= 0 ? colorIndex : (modelIndex === 0 ? 1 : 0)] || '').trim();
      if (!model) return;
      const previous = groups.get(model);
      if (!previous || (!previous.color && color)) {
        groups.set(model, { variant, color });
      }
    });

    const selected = [...groups.values()].map(({ variant }) => variant);
    if (!selected.length) return false;
    S.autoCompareApplied = true;
    S.mode = 'browse';
    $$('[data-mode]').forEach((button) => {
      button.classList.toggle('is-active', button.dataset.mode === 'browse');
    });
    ensureBrowseSlots(selected.length);
    S.slotVariant = {};
    Object.keys(S.slots).forEach((idx) => {
      S.slots[idx] = null;
    });
    selected.forEach((variant, index) => {
      const idx = String(index + 1);
      S.slots[idx] = product;
      S.slotVariant[idx] = variant;
    });
    setMode('browse');
    const modelSelects = $$('[data-role="model"]');
    const variantSelects = $$('[data-role="variant"]');
    selected.forEach((variant, index) => {
      const idx = String(index + 1);
      const modelSelect = modelSelects[index];
      const variantSelect = variantSelects[index];
      if (!modelSelect || !variantSelect) return;
      modelSelect.value = String(product.id);
      variantSelect.innerHTML = '<option value="">Select Variant</option>';
      getComparableVariants(product).forEach((item) => {
        const option = document.createElement('option');
        option.value = item.id;
        option.textContent = item.title;
        variantSelect.appendChild(option);
      });
      variantSelect.value = String(variant.id);
      variantSelect.disabled = false;
      refreshSlotCard(idx);
      $(`[data-slot="${idx}"]`)?.classList.add('has-product');
    });
    syncAllCombos();
    refreshSlotTable();
    return true;
  }

  function getVariantModelLabel(product, variant) {
    const modelIndex = (product.options || []).findIndex((option) =>
      /model|edition|version|size/i.test(option.name || '')
    );
    const values = variant?.options || [variant?.option1, variant?.option2, variant?.option3];
    return String(values[modelIndex >= 0 ? modelIndex : 0] || '').trim();
  }

  /* ── 模式切换 ── */
  function initModes() {
    $$('[data-mode]').forEach((btn) => {
      btn.addEventListener('click', () => {
        $$('[data-mode]').forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        setMode(btn.dataset.mode);
      });
    });
  }

  function setMode(mode) {
    S.mode = mode;
    hideAllPanels();
    if (mode === 'quiz') {
      showQuiz();
    } else {
      showBrowse();
    }
  }

  function hideAllPanels() {
    $$('[data-panel]').forEach((p) => (p.style.display = 'none'));
    const bar = $('[data-compare-bar]');
    if (bar) bar.style.display = 'none';
    const result = $('[data-compare-result]');
    if (result) result.style.display = 'none';
  }

  /* ── Loading ── */
  function showLoading() {
    $$('[data-panel]').forEach((p) => (p.style.display = 'none'));
    let el = $('.pc-loading');
    if (!el) {
      el = document.createElement('div');
      el.className = 'pc-loading';
      el.innerHTML = '<div class="pc-loading__spinner"></div>';
      $('.shopify-section--product-compare .container').appendChild(el);
    }
    el.style.display = '';
  }
  function hideLoading() {
    const el = $('.pc-loading');
    if (el) el.style.display = 'none';
  }

  /* ============================================================
     路径 A：问卷
     ============================================================ */
  function getQuizQuestions(cat) {
    const c = cat.toLowerCase().trim();
    return (CFG.quizQuestions || []).filter((q) => (q.category || '').toLowerCase().trim() === c);
  }

  function showQuiz() {
    const panel = $('[data-panel="quiz"]');
    panel.style.display = '';
    if (S.quiz.questions.length) {
      renderAllQuestions();
    } else {
      S.filtered = null;
      showProductGrid();
    }
  }

  /**
   * 一次渲染所有问卷问题，每题一个区块
   */
  function renderAllQuestions() {
    const questions = S.quiz.questions;
    const container = $('[data-quiz-steps]');
    const submitBtn = $('[data-quiz-submit]');
    const errorEl = $('[data-quiz-error]');
    const currentIndex = Math.min(Math.max(S.quiz.step || 0, 0), questions.length - 1);
    const question = questions[currentIndex];

    if (!question) return;
    if (submitBtn) submitBtn.style.display = 'none';
    if (errorEl) errorEl.style.display = 'none';

    const selected = S.quiz.answers[question.tagKey] || '';
    const progress = Math.round(((currentIndex + 1) / questions.length) * 100);
    container.innerHTML = `
      <div class="pc-quiz__step" data-quiz-question="${question.tagKey}">
        <div class="pc-quiz__nav">
          ${currentIndex > 0 ? '<button type="button" class="pc-quiz__back" data-quiz-back>&larr; Back</button>' : '<span class="pc-quiz__back-placeholder" aria-hidden="true"></span>'}
          <span class="pc-quiz__step-counter">Question ${currentIndex + 1} of ${questions.length}</span>
          <span class="pc-quiz__back-placeholder" aria-hidden="true"></span>
        </div>
        <div class="pc-quiz__progress" role="progressbar" aria-valuemin="1" aria-valuemax="${questions.length}" aria-valuenow="${currentIndex + 1}">
          <span style="width:${progress}%"></span>
        </div>
        <h3 class="pc-quiz__step-label">${question.label}</h3>
        <div class="pc-quiz__options">
          ${(question.options || [])
            .map(
              (o) => `
            <button type="button" class="pc-quiz__option ${selected === o.value ? 'is-selected' : ''}" data-quiz-tag="${question.tagKey}" data-quiz-val="${o.value}">
              <span class="pc-quiz__option-label">${o.label}</span>
            </button>`
            )
            .join('')}
        </div>
        <p class="pc-quiz__field-error" data-field-error="${question.tagKey}" style="display:none">Please select an option</p>
      </div>`;

    const backBtn = $('[data-quiz-back]', container);
    if (backBtn) {
      backBtn.addEventListener('click', () => {
        S.quiz.step = Math.max(currentIndex - 1, 0);
        renderAllQuestions();
      });
    }

    $$('.pc-quiz__option', container).forEach((btn) => {
      btn.addEventListener('click', () => {
        const tagKey = btn.dataset.quizTag;
        S.quiz.answers[tagKey] = btn.dataset.quizVal;
        const group = btn.closest('[data-quiz-question]');
        $$('.pc-quiz__option', group).forEach((b) => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');
        const fieldErr = $(`[data-field-error="${tagKey}"]`);
        if (fieldErr) fieldErr.style.display = 'none';
        group.classList.remove('has-error');
        if (currentIndex === questions.length - 1) {
          finishQuiz();
        } else {
          S.quiz.step = currentIndex + 1;
          renderAllQuestions();
        }
      });
    });
  }

  function initQuizNav() {
    const submitBtn = $('[data-quiz-submit]');
    if (submitBtn) submitBtn.style.display = 'none';
  }

  const priceFilterLabels = {
    all: 'All prices',
    under50: 'Under $50',
    '50-100': '$50-$100',
    '100-150': '$100-$150',
    '150-200': '$150-$200',
    over200: '$200+',
  };

  function parseComparablePrice(raw) {
    if (typeof raw === 'number' && Number.isFinite(raw)) return raw;
    if (raw == null || raw === '') return null;
    const normalized = String(raw).replace(/,/g, '').match(/-?\d+(?:\.\d+)?/);
    if (!normalized) return null;
    const value = Number(normalized[0]);
    if (Number.isFinite(value)) return value;
    return null;
  }

  function priceMatchesFilter(price, filter) {
    if (filter === 'all') return true;
    const value = parseComparablePrice(price);
    if (value == null) return false;
    if (filter === 'under50') return value < 50;
    if (filter === '50-100') return value >= 50 && value <= 100;
    if (filter === '100-150') return value > 100 && value <= 150;
    if (filter === '150-200') return value > 150 && value <= 200;
    if (filter === 'over200') return value > 200;
    return true;
  }

  function updatePriceFilterLabel() {
    const label = $('[data-price-filter-label]');
    if (label) label.textContent = priceFilterLabels[S.priceFilter] || priceFilterLabels.all;
    $$('[data-price-option]').forEach((option) => {
      option.classList.toggle('is-active', option.dataset.priceOption === S.priceFilter);
    });
  }

  function initPriceFilter() {
    const filter = $('[data-price-filter]');
    const toggle = $('[data-price-filter-toggle]');
    const menu = $('[data-price-filter-menu]');
    if (!filter || !toggle || !menu) return;

    toggle.addEventListener('click', (event) => {
      event.stopPropagation();
      const open = menu.hasAttribute('hidden');
      if (open) menu.removeAttribute('hidden');
      else menu.setAttribute('hidden', '');
      toggle.setAttribute('aria-expanded', String(open));
    });

    $$('[data-price-option]', filter).forEach((option) => {
      option.addEventListener('click', () => {
        S.priceFilter = option.dataset.priceOption || 'all';
        S.productPage = 1;
        updatePriceFilterLabel();
        menu.setAttribute('hidden', '');
        toggle.setAttribute('aria-expanded', 'false');
        showProductGrid();
      });
    });

    document.addEventListener('click', (event) => {
      if (!filter.contains(event.target)) {
        menu.setAttribute('hidden', '');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
    updatePriceFilterLabel();
  }

  function renderSelectionSummary() {
    const summary = $('[data-selection-summary]');
    const menu = $('[data-selection-summary-menu]');
    if (!summary || !menu) return;
    const questions = S.quiz.questions || [];
    if (!questions.length || !Array.isArray(S.filteredSkus)) {
      summary.style.display = 'none';
      return;
    }
    summary.style.display = '';
    menu.innerHTML = questions.map((question) => {
      const answer = S.quiz.answers[question.tagKey] || '';
      const selected = (question.options || []).find((option) => option.value === answer);
      const options = (question.options || []).map((option) => `
        <button type="button" class="pc-selection-summary__option${option.value === answer ? ' is-selected' : ''}"
          data-selection-option="${option.value}" data-selection-key="${question.tagKey}">${option.label}</button>`).join('');
      return `
        <div class="pc-selection-summary__item">
          <button type="button" class="pc-selection-summary__question" data-selection-question="${question.tagKey}" aria-expanded="false">
            <span>${question.label}</span>
            <span class="pc-selection-summary__value">${selected?.label || 'Not selected'} <span aria-hidden="true">&#9662;</span></span>
          </button>
          <div class="pc-selection-summary__options" data-selection-options="${question.tagKey}" hidden>${options}</div>
        </div>`;
    }).join('') + '<button type="button" class="pc-selection-summary__clear" data-selection-clear>Clear Filters</button>';
  }

  function initSelectionSummary() {
    const summary = $('[data-selection-summary]');
    const toggle = $('[data-selection-summary-toggle]');
    const menu = $('[data-selection-summary-menu]');
    if (!summary || !toggle || !menu) return;

    toggle.addEventListener('click', (event) => {
      event.stopPropagation();
      const open = menu.hasAttribute('hidden');
      if (open) {
        renderSelectionSummary();
        menu.removeAttribute('hidden');
      } else {
        menu.setAttribute('hidden', '');
      }
      toggle.setAttribute('aria-expanded', String(open));
    });

    menu.addEventListener('click', (event) => {
      if (event.target.closest('[data-selection-clear]')) {
        resetQuizResults();
        return;
      }
      const option = event.target.closest('[data-selection-option]');
      if (option) {
        S.quiz.answers[option.dataset.selectionKey] = option.dataset.selectionOption;
        menu.setAttribute('hidden', '');
        toggle.setAttribute('aria-expanded', 'false');
        finishQuiz();
        return;
      }
      const question = event.target.closest('[data-selection-question]');
      if (!question) return;
      const options = $(`[data-selection-options="${question.dataset.selectionQuestion}"]`, menu);
      const open = options?.hasAttribute('hidden');
      $$('[data-selection-options]', menu).forEach((el) => el.setAttribute('hidden', ''));
      $$('[data-selection-question]', menu).forEach((el) => el.setAttribute('aria-expanded', 'false'));
      if (open && options) {
        options.removeAttribute('hidden');
        question.setAttribute('aria-expanded', 'true');
      }
    });

    document.addEventListener('click', (event) => {
      if (!summary.contains(event.target)) {
        menu.setAttribute('hidden', '');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /**
   * 判断单个产品是否命中某条匹配规则
   * @param {object} product - 产品对象
   * @param {object} rule - 匹配规则 { key, contains, range, type }
   * @returns {boolean}
   */
  function matchSpec(product, rule) {
    if (!rule) return false;

    /* 价格范围匹配 */
    if (rule.type === 'price') {
      const price = parseFloat(product.variants?.[0]?.price);
      if (isNaN(price) || !rule.range) return false;
      return price >= rule.range[0] && price <= rule.range[1];
    }

    /* 从 metafield specs 取值（产品级别，遍历所有 variant 取第一个有值的） */
    const specVal = tagVal(product, rule.key || '');
    if (!specVal) return false;
    const lower = specVal.toLowerCase();

    /* contains：metafield 值包含任一关键词即命中 */
    if (rule.contains && rule.contains.length) {
      return rule.contains.some((kw) => lower.includes(kw.toLowerCase()));
    }

    /* range：从 metafield 值提取数字，判断是否在范围内 */
    if (rule.range) {
      const numMatch = specVal.match(/([\d.]+)/);
      if (!numMatch) return false;
      const num = parseFloat(numMatch[1]);
      return !isNaN(num) && num >= rule.range[0] && num <= rule.range[1];
    }

    return false;
  }

  /**
   * 对单个 variant 进行匹配评分
   * @param {object} product - 产品对象
   * @param {object} variant - variant 对象
   * @param {object} rule - 匹配规则
   * @returns {boolean}
   */
  function matchSpecVariant(product, variant, rule) {
    if (!rule) return false;
    if (rule.type === 'price') {
      const price = parseFloat(variant.price);
      if (isNaN(price) || !rule.range) return false;
      return price >= rule.range[0] && price <= rule.range[1];
    }
    const specVal = tagVal(product, rule.key || '', variant.id);
    if (!specVal) return false;
    const lower = specVal.toLowerCase();
    if (rule.contains && rule.contains.length) {
      return rule.contains.some((kw) => lower.includes(kw.toLowerCase()));
    }
    if (rule.range) {
      const numMatch = specVal.match(/([\d.]+)/);
      if (!numMatch) return false;
      const num = parseFloat(numMatch[1]);
      return !isNaN(num) && num >= rule.range[0] && num <= rule.range[1];
    }
    return false;
  }

  /**
   * 问卷完成：展开所有产品的 variant，逐个 SKU 评分排序
   */
  const normalizeFinderText = (value) => String(value || '').toLowerCase().trim().replace(/\s+/g, '');

  function parseFinderWeight(value) {
    const match = String(value || '').match(/[\d]+(?:[.,]\d+)?/);
    if (!match) return null;
    const weight = parseFloat(match[0].replace(',', '.'));
    return Number.isFinite(weight) ? weight : null;
  }

  function parseFinderGrip(value) {
    const normalized = String(value || '').toLowerCase();
    return ['palm', 'claw', 'fingertip'].filter((grip) => normalized.includes(grip));
  }

  function normalizeFinderHandSize(value) {
    const normalized = String(value || '').toLowerCase().replace(/\s+/g, '');
    if (normalized.includes('universal')) return 'universal';
    if (normalized.includes('small-to-medium') || normalized.includes('smalltomedium')) return 'small-to-medium';
    if (normalized.includes('medium-to-large') || normalized.includes('mediumtolarge')) return 'medium-to-large';
    if (normalized.includes('small')) return 'small';
    if (normalized.includes('large')) return 'large';
    if (normalized.includes('medium')) return 'medium';
    return 'unknown';
  }

  function finderPerformanceFromSensor(value) {
    const performanceMap = {
      xheroai: 'entry', pwa3311: 'entry', paw3395se: 'advanced', paw3395: 'advanced',
      paw3395ultra: 'advanced', paw3950: 'advanced', paw3950ultra: 'pro', paw3955master: 'pro',
    };
    return performanceMap[normalizeFinderText(value)] || 'unknown';
  }

  function finderBudgetMatch(price, answer) {
    const value = parseFloat(price);
    if (!Number.isFinite(value)) return false;
    if (answer === 'under50') return value < 50;
    if (answer === '50-100') return value >= 50 && value <= 100;
    if (answer === '100-150') return value > 100 && value <= 150;
    return true;
  }

  function finderVariantData(product, variant, index) {
    const weight = parseFinderWeight(tagVal(product, 'weight', variant.id));
    const grip = parseFinderGrip(tagVal(product, 'grip_style', variant.id));
    const handSize = normalizeFinderHandSize(tagVal(product, 'best_for_hand_size', variant.id));
    return {
      product, variant, variantIndex: index, weight, grip, handSize,
      performance: finderPerformanceFromSensor(tagVal(product, 'sensor', variant.id)),
      price: parseFloat(variant.price), available: variant.available !== false,
    };
  }

  function finderConditionMatches(data, key, answer) {
    if (key === 'hand_size') {
      const allowed = {
        small: ['small', 'small-to-medium', 'universal'],
        medium: ['small-to-medium', 'medium', 'medium-to-large', 'universal'],
        large: ['medium-to-large', 'large', 'universal'],
      };
      return (allowed[answer] || []).includes(data.handSize);
    }
    if (key === 'grip_style') return data.grip.includes(answer);
    if (key === 'performance') return data.performance === answer;
    if (key === 'weight_pref') {
      if (data.weight == null) return false;
      if (answer === '35-39') return data.weight >= 35 && data.weight <= 39;
      if (answer === '40-50') return data.weight >= 40 && data.weight <= 50;
      if (answer === '50+') return data.weight > 50;
    }
    return false;
  }

  function finderRankCompare(a, b, useBudgetPriority) {
    if (useBudgetPriority && a.budgetEligible !== b.budgetEligible) {
      return Number(b.budgetEligible) - Number(a.budgetEligible);
    }
    if (a.matched !== b.matched) return b.matched - a.matched;
    if (a.matchPct !== b.matchPct) return b.matchPct - a.matchPct;
    return a.productIndex - b.productIndex || a.variantIndex - b.variantIndex;
  }

  function finderSpecValue(product, variant, aliases) {
    const values = aliases.map((alias) => tagVal(product, alias, variant.id)).filter(Boolean);
    if (values.length) return values[0];

    const productSpecs = S.variantSpecsCache?.[String(product.id)];
    const variantSpecs = productSpecs?.[String(variant.id)] || {};
    const normalizeKey = (value) => String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '');
    const wanted = aliases.map(normalizeKey);
    const entry = Object.entries(variantSpecs).find(([key, spec]) =>
      wanted.includes(normalizeKey(key)) || wanted.includes(normalizeKey(spec.label))
    );
    return entry?.[1]?.value || '';
  }

  function normalizeKeyboardLayout(value) {
    const normalized = String(value || '').toLowerCase().trim();
    if (/full[\s-]*size/.test(normalized)) return 'full';
    const match = normalized.match(/(?:^|[^0-9])(60|65|75|80|90|95|96|98|100)\s*%?/);
    if (!match) return 'unknown';
    const percentage = Number(match[1]);
    if ([60, 65].includes(percentage)) return 'compact';
    if ([75, 80].includes(percentage)) return 'balanced';
    if ([90, 95, 96, 98, 100].includes(percentage)) return 'full';
    return 'unknown';
  }

  function normalizeKeyboardSwitch(value) {
    const normalized = String(value || '').toLowerCase().trim();
    if (normalized.includes('magnetic')) return 'magnetic';
    if (normalized.includes('mechanical')) return 'mechanical';
    return 'unknown';
  }

  function keyboardBudgetMatch(price, answer) {
    const value = parseFloat(price);
    if (!Number.isFinite(value) || answer === 'any' || answer === '*') return true;
    if (answer === 'under100') return value < 100;
    if (answer === '100-200') return value >= 100 && value <= 200;
    if (answer === '200-300') return value > 200 && value <= 300;
    return true;
  }

  function keyboardVariantData(product, variant, index) {
    return {
      product,
      variant,
      variantIndex: index,
      layout: normalizeKeyboardLayout(finderSpecValue(product, variant, ['layout / size', 'layout_size'])),
      switchType: normalizeKeyboardSwitch(finderSpecValue(product, variant, ['switch type', 'switch_type'])),
      price: parseFloat(variant.price),
      available: variant.available !== false,
    };
  }

  function finishKeyboardQuiz(products, answers) {
    const activeKeys = ['layout', 'switch_type'].filter(
      (key) => answers[key] && answers[key] !== 'any' && answers[key] !== '*'
    );
    const hasBudget = answers.kb_budget && answers.kb_budget !== 'any' && answers.kb_budget !== '*';
    const candidates = [];

    products.forEach((product, productIndex) => {
      (product.variants || []).forEach((variant, variantIndex) => {
        const data = keyboardVariantData(product, variant, variantIndex);
        if (!data.available) return;
        const budgetEligible = !hasBudget || keyboardBudgetMatch(data.price, answers.kb_budget);
        const matched = activeKeys.reduce((total, key) => {
          if (key === 'layout') return total + (data.layout === answers.layout ? 1 : 0);
          return total + (data.switchType === answers.switch_type ? 1 : 0);
        }, 0);
        candidates.push({
          ...data,
          productIndex,
          budgetEligible,
          matched,
          matchPct: activeKeys.length ? Math.round((matched / activeKeys.length) * 100) : 100,
          _score: matched,
          _pct: activeKeys.length ? Math.round((matched / activeKeys.length) * 100) : 100,
        });
      });
    });

    const budgetCandidates = hasBudget ? candidates.filter((item) => item.budgetEligible) : candidates;
    const useBudgetPriority = hasBudget && budgetCandidates.length > 0;
    const pool = hasBudget ? budgetCandidates : candidates;
    const rankedPool = activeKeys.length ? pool.filter((item) => item.matched === activeKeys.length) : pool;
    S.filteredSkus = [...rankedPool]
      .sort((a, b) => finderRankCompare(a, b, useBudgetPriority));
    S.filtered = null;
    S.productPage = 1;
    $('[data-panel="quiz"]').style.display = 'none';
    showProductGrid();
  }

  function finishQuiz() {
    const products = S.products[S.category] || [];
    const answers = S.quiz.answers;
    if (S.category.toLowerCase().trim() === 'keyboards') {
      finishKeyboardQuiz(products, answers);
      return;
    }
    const finderKeys = ['hand_size', 'grip_style', 'performance', 'weight_pref'];
    // 'any' answers intentionally stay outside the score denominator.
    const activeKeys = finderKeys.filter((key) => answers[key] && answers[key] !== 'any' && answers[key] !== '*');
    const hasBudget = answers.budget && answers.budget !== 'any' && answers.budget !== '*';
    const candidates = [];

    products.forEach((product, productIndex) => {
      (product.variants || []).forEach((variant, variantIndex) => {
        const data = finderVariantData(product, variant, variantIndex);
        if (!data.available) return;
        const budgetEligible = !hasBudget || finderBudgetMatch(data.price, answers.budget);
        const matched = activeKeys.reduce(
          (total, key) => total + (finderConditionMatches(data, key, answers[key]) ? 1 : 0), 0
        );
        candidates.push({
          ...data,
          productIndex,
          budgetEligible,
          matched,
          matchPct: activeKeys.length ? Math.round((matched / activeKeys.length) * 100) : 100,
          _score: matched,
          _pct: activeKeys.length ? Math.round((matched / activeKeys.length) * 100) : 100,
        });
      });
    });

    const budgetCandidates = hasBudget ? candidates.filter((item) => item.budgetEligible) : candidates;
    const useBudgetPriority = hasBudget && budgetCandidates.length > 0;
    const pool = hasBudget ? budgetCandidates : candidates;
    const rankedPool = activeKeys.length ? pool.filter((item) => item.matched === activeKeys.length) : pool;
    S.filteredSkus = [...rankedPool]
      .sort((a, b) => finderRankCompare(a, b, useBudgetPriority));
    S.filtered = null;
    S.productPage = 1;
    $('[data-panel="quiz"]').style.display = 'none';
    showProductGrid();
    return;

  }

  function resetQuizResults() {
    S.filtered = null;
    S.filteredSkus = null;
    S.priceFilter = 'all';
    S.productPage = 1;
    updatePriceFilterLabel();
    S.checked = [];
    S.quiz = { step: 0, answers: {}, questions: getQuizQuestions(S.category) };
    const summaryMenu = $('[data-selection-summary-menu]');
    const summaryToggle = $('[data-selection-summary-toggle]');
    if (summaryMenu) summaryMenu.setAttribute('hidden', '');
    if (summaryToggle) summaryToggle.setAttribute('aria-expanded', 'false');
    $('[data-panel="products"]').style.display = 'none';
    showQuiz();
  }

  /* ============================================================
     产品网格（问卷结果）
     ============================================================ */
  function showProductGrid() {
    const panel = $('[data-panel="products"]');
    panel.style.display = '';
    const grid = $('[data-product-grid]');
    const skuMode = Array.isArray(S.filteredSkus);
    const countEl = $('[data-product-count]');
    const priceFilterEl = $('[data-price-filter]');
    const pagination = $('[data-product-pagination]');
    if (priceFilterEl) priceFilterEl.style.display = skuMode ? '' : 'none';
    renderSelectionSummary();

    if (skuMode) {
      /* SKU 级别展示（问卷推荐结果） */
      const skus = S.filteredSkus
        .filter((s) => variantHasSpecs(s.product, s.variant.id))
        .filter((s) => priceMatchesFilter(s.variant?.price, S.priceFilter));
      countEl.textContent = `${skus.length} Options Found`;

      if (!skus.length) {
        if (pagination) {
          pagination.hidden = true;
          pagination.innerHTML = '';
        }
        grid.innerHTML = S.priceFilter !== 'all'
          ? '<div class="pc-products__empty"><p>No options match this price range.</p><button type="button" class="pc-products__empty-clear" data-clear-price-filter>Clear Price Filter</button></div>'
          : '<div class="pc-products__empty"><p>Comparison data is being added for this category. Please check back soon.</p></div>';
        const clearPrice = $('[data-clear-price-filter]', grid);
        if (clearPrice) {
          clearPrice.addEventListener('click', () => {
            S.priceFilter = 'all';
            updatePriceFilterLabel();
            showProductGrid();
          });
        }
        return;
      }

      const pageSize = getProductPageSize(grid);
      const pageCount = Math.ceil(skus.length / pageSize);
      S.productPage = Math.min(Math.max(S.productPage, 1), pageCount);
      const pageStart = (S.productPage - 1) * pageSize;
      const visibleSkus = skus.slice(pageStart, pageStart + pageSize);

      grid.innerHTML = visibleSkus
        .map((s) => {
          const p = s.product;
          const v = s.variant;
          const vImg = v.featured_image?.src || p.images?.[0]?.src || p.image?.src || '';
          const variantValues = v.title && v.title !== 'Default Title'
            ? v.title.split('/').map((value) => value.trim()).filter(Boolean)
            : [];
          const variantBadges = variantValues.length
            ? `<div class="pc-product-card__variants" aria-label="Variant">${variantValues
              .map((value) => `<span class="pc-product-card__variant-badge">${value}</span>`)
              .join('')}</div>`
            : '';
          const vTitle = p.title;
          const checked = S.checked.includes(String(p.id) + '_' + String(v.id));
          const buyUrl = `${CFG.shopUrl}/products/${p.handle}?variant=${v.id}`;
          return `
          <div class="pc-product-card ${checked ? 'is-checked' : ''}" data-pid="${p.id}" data-vid="${v.id}">
            <div class="pc-product-card__check">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2.5 7L5.5 10L11.5 4" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </div>
            <img class="pc-product-card__image" src="${imgSrc(vImg, '300x300')}" alt="${vTitle}" loading="lazy" decoding="async" width="300" height="300">
            <h4 class="pc-product-card__title">${vTitle}</h4>
            ${variantBadges}
            <span class="pc-product-card__price">${money(v.price)}</span>
            <a class="pc-product-card__buy" href="${buyUrl}">Buy Now</a>
          </div>`;
        })
        .join('');
      renderProductPagination(pagination, pageCount);

      $$('.pc-product-card', grid).forEach((card) => {
        card.addEventListener('click', (e) => {
          if (e.target.closest('.pc-product-card__buy')) return;
          const key = card.dataset.pid + '_' + card.dataset.vid;
          toggleCheck(key);
        });
      });
    } else {
      /* 产品级别展示（非问卷模式） */
      const items = (S.filtered || S.products[S.category] || []).filter(productHasSpecs);
      if (S.filtered) {
        countEl.textContent = `${items.length} products found`;
      } else {
        countEl.textContent = `All ${items.length} products`;
      }

      if (!items.length) {
        if (pagination) {
          pagination.hidden = true;
          pagination.innerHTML = '';
        }
        grid.innerHTML =
          '<div class="pc-products__empty"><p>Comparison data is being added for this category. Please check back soon.</p></div>';
        return;
      }

      const pageSize = getProductPageSize(grid);
      const pageCount = Math.ceil(items.length / pageSize);
      S.productPage = Math.min(Math.max(S.productPage, 1), pageCount);
      const pageStart = (S.productPage - 1) * pageSize;
      const visibleItems = items.slice(pageStart, pageStart + pageSize);

      grid.innerHTML = visibleItems
        .map((p) => {
          const img = p.images?.[0]?.src || p.image?.src || '';
          const checked = S.checked.includes(String(p.id));
          const seriesName = findSeriesName(p.id);
          return `
          <div class="pc-product-card ${checked ? 'is-checked' : ''}" data-pid="${p.id}">
            <div class="pc-product-card__check">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2.5 7L5.5 10L11.5 4" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </div>
            <img class="pc-product-card__image" src="${imgSrc(img, '300x300')}" alt="${p.title}" loading="lazy" decoding="async" width="300" height="300">
            <h4 class="pc-product-card__title">${p.title}</h4>
            ${seriesName ? `<p class="pc-product-card__series">${seriesName}</p>` : ''}
            <span class="pc-product-card__price">${money(p.variants?.[0]?.price)}</span>
          </div>`;
        })
        .join('');
      renderProductPagination(pagination, pageCount);

      $$('.pc-product-card', grid).forEach((card) => {
        card.addEventListener('click', (e) => {
          if (e.target.closest('.pc-product-card__buy')) return;
          toggleCheck(card.dataset.pid);
        });
      });
    }

    updateCompareBar();

    const backBtn = $('[data-products-back]');
    if (backBtn) {
      backBtn.onclick = () => {
        resetQuizResults();
      };
    }
  }

  function getProductPageSize(grid) {
    const columns = getComputedStyle(grid).gridTemplateColumns
      .trim()
      .split(/\s+/)
      .filter(Boolean).length;
    return Math.max(1, columns || 2) * PRODUCT_PAGE_ROWS;
  }

  function renderProductPagination(container, pageCount) {
    if (!container) return;
    if (pageCount <= 1) {
      container.hidden = true;
      container.innerHTML = '';
      return;
    }

    container.hidden = false;
    const pageItems = [];
    for (let page = 1; page <= pageCount; page++) {
      if (page === 1 || page === pageCount || Math.abs(page - S.productPage) <= 1) {
        pageItems.push(`<button type="button" class="pc-products__pagination-btn pc-products__pagination-page${page === S.productPage ? ' is-active' : ''}" data-product-page="${page}" aria-label="Page ${page}" ${page === S.productPage ? 'aria-current="page"' : ''}>${page}</button>`);
      } else if (pageItems[pageItems.length - 1] !== '<span class="pc-products__pagination-ellipsis" aria-hidden="true">…</span>') {
        pageItems.push('<span class="pc-products__pagination-ellipsis" aria-hidden="true">…</span>');
      }
    }

    container.innerHTML = `
      <button type="button" class="pc-products__pagination-btn" data-product-page="prev" aria-label="Previous page" ${S.productPage === 1 ? 'disabled' : ''}>
        <span aria-hidden="true">&#8592;</span> Previous
      </button>
      <div class="pc-products__pagination-pages">${pageItems.join('')}</div>
      <button type="button" class="pc-products__pagination-btn" data-product-page="next" aria-label="Next page" ${S.productPage === pageCount ? 'disabled' : ''}>
        Next <span aria-hidden="true">&#8594;</span>
      </button>`;

    container.querySelector('[data-product-page="prev"]')?.addEventListener('click', () => {
      S.productPage = Math.max(1, S.productPage - 1);
      showProductGrid();
      container.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    });
    container.querySelector('[data-product-page="next"]')?.addEventListener('click', () => {
      S.productPage = Math.min(pageCount, S.productPage + 1);
      showProductGrid();
      container.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    });
    container.querySelectorAll('[data-product-page]:not([data-product-page="prev"]):not([data-product-page="next"])').forEach((button) => {
      button.addEventListener('click', () => {
        S.productPage = Number(button.dataset.productPage);
        showProductGrid();
        container.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      });
    });
  }

  function findSeriesName(pid) {
    const map = S.seriesMap[S.category] || {};
    for (const h in map) {
      if (map[h].products.some((p) => p.id === pid)) return map[h].title;
    }
    return '';
  }

  function toggleCheck(key) {
    key = String(key);
    const idx = S.checked.indexOf(key);
    if (idx >= 0) {
      S.checked.splice(idx, 1);
    } else {
      if (S.checked.length >= 4) return;
      S.checked.push(key);
    }
    /* 同步所有卡片的选中状态 */
    $$('.pc-product-card').forEach((c) => {
      const cardKey = c.dataset.vid
        ? String(c.dataset.pid) + '_' + String(c.dataset.vid)
        : String(c.dataset.pid);
      const isChecked = S.checked.indexOf(cardKey) >= 0;
      if (isChecked) {
        c.classList.add('is-checked');
      } else {
        c.classList.remove('is-checked');
      }
    });
    /* 强制更新按钮数字 */
    const topBtn = $('[data-top-compare]');
    const topCount = $('[data-top-compare-count]');
    if (topBtn) {
      topCount.textContent = S.checked.length;
      topBtn.style.display = S.checked.length > 0 ? '' : 'none';
    }
  }

  /* ── 顶部对比按钮 ── */
  function updateCompareBar() {
    const topBtn = $('[data-top-compare]');
    const topCount = $('[data-top-compare-count]');
    if (topBtn) {
      if (S.checked.length) {
        topBtn.style.display = '';
        topCount.textContent = S.checked.length;
      } else {
        topBtn.style.display = 'none';
      }
    }
  }

  function initCompareBar() {
    $('[data-top-compare]')?.addEventListener('click', () => {
      if (!S.checked.length) return;
      showQuizCompareResult();
    });
  }

  /* ── 问卷对比结果 ── */
  function showQuizCompareResult() {
    hideAllPanels();
    const panel = $('[data-compare-result]');
    panel.style.display = '';
    const allProducts = S.products[S.category] || [];
    const selectedEntries = S.checked
      .map((key) => {
        const [pid, vid] = String(key).split('_');
        const product = allProducts.find((x) => String(x.id) === pid);
        if (!product) return null;
        const variant = vid
          ? (product.variants || []).find((v) => String(v.id) === vid)
          : getComparableVariants(product)[0] || product.variants?.[0];
        if (!variant || !variantHasSpecs(product, variant.id)) return null;
        return { product, variant };
      })
      .filter(Boolean);
    const selected = selectedEntries.map((entry) => entry.product);
    const variantIds = selectedEntries.map((entry) => String(entry.variant.id));

    panel.style.setProperty('--compare-cols', selected.length);

    const cards = $('[data-compare-cards]');
    cards.innerHTML = selectedEntries
      .map(({ product: p, variant: v }) => {
        const title = v.title && v.title !== 'Default Title' ? `${p.title} - ${v.title}` : p.title;
        const img = v.featured_image?.src || p.images?.[0]?.src || p.image?.src || '';
        return `
        <div class="pc-compare-card">
          <img class="pc-compare-card__image" src="${imgSrc(img, '300x300')}" alt="${title}" loading="lazy" decoding="async" width="300" height="300">
          <h4 class="pc-compare-card__title">${title}</h4>
          <p class="pc-compare-card__price">${money(v.price)}</p>
          <a class="pc-compare-card__buy button button--primary" href="${CFG.shopUrl}/products/${p.handle}?variant=${v.id}">Buy Now</a>
        </div>`;
      })
      .join('');

    renderSpecTable(selected, '[data-compare-thead]', '[data-compare-tbody]', variantIds);
    initDiffToggle('[data-toggle-diff]', '[data-compare-tbody]');
  }

  function initBackButton() {
    $('[data-back-to-grid]')?.addEventListener('click', () => {
      $('[data-compare-result]').style.display = 'none';
      showProductGrid();
      $('[data-panel="products"]').style.display = '';
      updateCompareBar();
    });
  }

  /* ============================================================
     路径 B：Keychron 风格下拉选择
     ============================================================ */
  function showBrowse() {
    const panel = $('[data-panel="browse"]');
    panel.style.display = '';
    ensureBrowseSlots(Math.max(4, Object.keys(S.slots).length));
    populateModelDropdowns();
    refreshSlotCards();
    refreshSlotTable();
  }

  function getSlotIndexes() {
    return Object.keys(S.slots).sort((a, b) => Number(a) - Number(b));
  }

  function ensureBrowseSlots(count) {
    const grid = $('[data-panel="browse"] .pc-slots__grid');
    const template = grid?.querySelector('.pc-slot');
    if (!grid || !template) return;
    let current = grid.querySelectorAll('.pc-slot').length;
    while (current < count) {
      current += 1;
      const slot = template.cloneNode(true);
      slot.dataset.slot = String(current);
      slot.querySelectorAll('[data-slot], [data-slot-card], [data-slot-empty], [data-slot-remove], [data-slot-add], [data-slot-title], [data-slot-variants], [data-slot-img], [data-slot-price], [data-slot-url]').forEach((el) => {
        ['data-slot', 'data-slot-card', 'data-slot-empty', 'data-slot-remove', 'data-slot-add', 'data-slot-title', 'data-slot-variants', 'data-slot-img', 'data-slot-price', 'data-slot-url'].forEach((attr) => {
          if (el.hasAttribute(attr)) el.setAttribute(attr, String(current));
        });
      });
      slot.querySelectorAll('.pc-combo').forEach((combo) => combo.remove());
      slot.querySelectorAll('select').forEach((select) => {
        select.dataset.slot = String(current);
        select.removeAttribute('data-events-bound');
        select.value = '';
        if (select.dataset.role === 'variant') select.disabled = true;
        select.innerHTML = select.dataset.role === 'variant'
          ? '<option value="">Select Variant</option>'
          : '<option value="">Select Model</option>';
      });
      slot.querySelector('[data-slot-card]')?.setAttribute('style', 'display:none');
      const empty = slot.querySelector('[data-slot-empty]');
      if (empty) empty.style.display = '';
      slot.querySelectorAll('[data-role="model"], [data-role="variant"], [data-slot-remove], [data-slot-add]').forEach((el) => {
        el.removeAttribute('data-events-bound');
      });
      const addButton = grid.querySelector('[data-add-browse-slot]');
      if (addButton) grid.insertBefore(slot, addButton);
      else grid.appendChild(slot);
      S.slots[String(current)] = null;
    }
    initSlotEvents();
  }

  /**
   * 根据当前分类，将所有产品直接填入 Model 下拉
   */
  function populateModelDropdowns() {
    const allProducts = S.products[S.category] || [];
    const sortedProducts = [...allProducts].sort((a, b) =>
      (a.title || '').localeCompare(b.title || '', undefined, { sensitivity: 'base', numeric: true })
    );
    $$('[data-role="model"]').forEach((sel) => {
      const current = sel.value;
      sel.innerHTML = '<option value="">Select Model</option>';
      sortedProducts.forEach((p) => {
        const opt = document.createElement('option');
        opt.value = p.id;
        opt.textContent = p.title;
        sel.appendChild(opt);
      });
      sel.disabled = false;
      if (current && allProducts.some((p) => String(p.id) === current)) sel.value = current;
    });
    syncAllCombos();
  }

  function initSlotEvents() {
    /* 为所有 select 创建 combobox */
    $$('.pc-slot__select').forEach((sel) => createCombo(sel));

    /* Model 切换 → 填充 Variant 下拉，等 Variant 选择后才显示卡片 */
    $$('[data-role="model"]:not([data-events-bound])').forEach((sel) => {
      sel.setAttribute('data-events-bound', 'true');
      sel.addEventListener('change', () => {
        const slotIdx = sel.dataset.slot;
        const variantSel = $(`[data-role="variant"][data-slot="${slotIdx}"]`);
        variantSel.innerHTML = '<option value="">Select Variant</option>';
        variantSel.disabled = true;

        const pid = sel.value;
        if (!pid) {
          clearSlot(slotIdx);
          syncAllCombos();
          return;
        }
        const allProducts = S.products[S.category] || [];
        const product = allProducts.find((p) => String(p.id) === pid);
        if (!product) return;

        const variants = getComparableVariants(product);
        if (!variants.length) {
          clearSlot(slotIdx);
          syncAllCombos();
          return;
        }

        if (variants.length <= 1) {
          /* 只有一个 variant（Default Title），直接选中并显示 */
          S.slots[slotIdx] = product;
          S.slotVariant = S.slotVariant || {};
          S.slotVariant[slotIdx] = variants[0] || null;
          syncAllCombos();
          refreshSlotCard(slotIdx);
          refreshSlotTable();
          $(`[data-slot="${slotIdx}"]`)?.classList.add('has-product');
        } else {
          /* 多个 variant：先清空卡片，等用户选 variant */
          clearSlot(slotIdx);
          variants.forEach((v) => {
            const opt = document.createElement('option');
            opt.value = v.id;
            opt.textContent = v.title;
            variantSel.appendChild(opt);
          });
          variantSel.disabled = false;
          syncAllCombos();
        }
      });
    });

    /* Variant 切换 → 设置产品 + variant 并显示卡片 */
    $$('[data-role="variant"]:not([data-events-bound])').forEach((sel) => {
      sel.setAttribute('data-events-bound', 'true');
      sel.addEventListener('change', () => {
        const slotIdx = sel.dataset.slot;
        const vid = sel.value;
        if (!vid) {
          /* 清空卡片但保留 variant 下拉选项，让用户可以重新选 */
          S.slots[slotIdx] = null;
          if (S.slotVariant) S.slotVariant[slotIdx] = null;
          $(`[data-slot-card="${slotIdx}"]`).style.display = 'none';
          $(`[data-slot-empty="${slotIdx}"]`).style.display = '';
          $(`[data-slot="${slotIdx}"]`)?.classList.remove('has-product');
          refreshSlotTable();
          return;
        }

        /* 从 Model 下拉获取产品（兼容 S.slots 尚未设置的情况） */
        const modelSel = $(`[data-role="model"][data-slot="${slotIdx}"]`);
        const pid = modelSel?.value;
        const allProducts = S.products[S.category] || [];
        const p = allProducts.find((x) => String(x.id) === pid);
        if (!p) return;

        const variant = (p.variants || []).find((v) => String(v.id) === vid);
        if (!variant) return;

        S.slots[slotIdx] = p;
        S.slotVariant = S.slotVariant || {};
        S.slotVariant[slotIdx] = variant;

        const imgEl = $(`[data-slot-img="${slotIdx}"]`);
        if (variant.featured_image && variant.featured_image.src) {
          imgEl.src = imgSrc(variant.featured_image.src, '400x400');
        } else {
          const fallback = p.images?.[0]?.src || p.image?.src || '';
          imgEl.src = imgSrc(fallback, '400x400');
        }
        $(`[data-slot-price="${slotIdx}"]`).textContent = money(variant.price);
        const urlEl = $(`[data-slot-url="${slotIdx}"]`);
        urlEl.href = `${CFG.shopUrl}/products/${p.handle}?variant=${variant.id}`;
        refreshSlotCard(slotIdx);
        refreshSlotTable();
        $(`[data-slot="${slotIdx}"]`)?.classList.add('has-product');
      });
    });

    $$('[data-slot-remove]:not([data-events-bound])').forEach((btn) => {
      btn.setAttribute('data-events-bound', 'true');
      btn.addEventListener('click', () => {
        const idx = btn.dataset.slotRemove;
        const slot = $(`[data-slot="${idx}"]`);
        const slotCount = getSlotIndexes().length;
        if (slotCount > 1) {
          delete S.slots[idx];
          if (S.slotVariant) delete S.slotVariant[idx];
          slot?.remove();
          refreshSlotTable();
          return;
        }
        clearSlot(idx);
        const modelSel = $(`[data-role="model"][data-slot="${idx}"]`);
        const variantSel = $(`[data-role="variant"][data-slot="${idx}"]`);
        if (modelSel) modelSel.value = '';
        if (variantSel) {
          variantSel.innerHTML = '<option value="">Select Variant</option>';
          variantSel.disabled = true;
        }
        syncAllCombos();
      });
    });

    $$('[data-slot-add]:not([data-events-bound])').forEach((btn) => {
      btn.setAttribute('data-events-bound', 'true');
      btn.addEventListener('click', () => addBrowseSlot());
    });

    const addSlotButton = $('[data-add-browse-slot]');
    if (addSlotButton && addSlotButton.dataset.eventsBound !== 'true') {
      addSlotButton.dataset.eventsBound = 'true';
      addSlotButton.addEventListener('click', () => addBrowseSlot());
    }

    const clearButton = $('[data-clear-slots]');
    if (clearButton && clearButton.dataset.eventsBound !== 'true') {
      clearButton.dataset.eventsBound = 'true';
      clearButton.addEventListener('click', clearAllBrowseSlots);
    }
  }

  function addBrowseSlot() {
    const grid = $('[data-panel="browse"] .pc-slots__grid');
    const placeholder = grid?.querySelector('.pc-slot.is-add-placeholder');
    if (placeholder) {
      placeholder.classList.remove('is-add-placeholder');
      const selectors = placeholder.querySelector('.pc-slot__selectors');
      if (selectors) selectors.style.display = '';
      populateModelDropdowns();
      initSlotEvents();
      placeholder.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      updateBrowseAddControl();
      return;
    }
    const count = grid?.querySelectorAll('.pc-slot').length || 0;
    ensureBrowseSlots(count + 1);
    populateModelDropdowns();
    syncAllCombos();
    grid?.querySelector('.pc-slot:last-of-type')?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  }

  function clearAllBrowseSlots() {
    const grid = $('[data-panel="browse"] .pc-slots__grid');
    const first = grid?.querySelector('.pc-slot');
    if (!grid || !first) return;
    grid.querySelectorAll('.pc-slot').forEach((slot, index) => {
      if (index > 0) slot.remove();
    });
    S.slots = { 1: null };
    S.slotVariant = {};
    first.classList.add('is-add-placeholder');
    clearSlot('1');
    const modelSelect = $('[data-role="model"][data-slot="1"]');
    if (modelSelect) modelSelect.value = '';
    syncAllCombos();
    refreshSlotTable();
  }

  function updateBrowseAddControl() {
    const button = $('[data-add-browse-slot]');
    if (button) button.style.display = getSlotIndexes().some((idx) => S.slots[idx]) ? '' : 'none';
  }

  function clearSlot(idx) {
    S.slots[idx] = null;
    if (S.slotVariant) S.slotVariant[idx] = null;
    $(`[data-slot-card="${idx}"]`).style.display = 'none';
    $(`[data-slot-empty="${idx}"]`).style.display = '';
    $(`[data-slot="${idx}"]`)?.classList.remove('has-product');
    const imgEl = $(`[data-slot-img="${idx}"]`);
    if (imgEl) {
      imgEl.removeAttribute('src');
      imgEl.alt = '';
    }
    const variantSel = $(`[data-role="variant"][data-slot="${idx}"]`);
    if (variantSel) {
      variantSel.innerHTML = '<option value="">Select Variant</option>';
      variantSel.disabled = true;
    }
    refreshSlotTable();
  }

  function resetSlots() {
    getSlotIndexes().forEach((i) => clearSlot(i));
    const grid = $('[data-panel="browse"] .pc-slots__grid');
    grid?.querySelectorAll('.pc-slot').forEach((slot) => {
      if (Number(slot.dataset.slot) > 4) slot.remove();
    });
    Object.keys(S.slots).forEach((idx) => {
      if (Number(idx) > 4) delete S.slots[idx];
    });
    S.slotVariant = {};
    $$('[data-role="model"]').forEach((s) => (s.value = ''));
    $$('[data-role="variant"]').forEach((s) => {
      s.innerHTML = '<option value="">Select Variant</option>';
      s.disabled = true;
    });
    syncAllCombos();
  }

  function refreshSlotCard(idx) {
    const p = S.slots[idx];
    if (!p) return;
    const sv = (S.slotVariant || {})[idx] || p.variants?.[0];
    const variantImg = sv?.featured_image?.src;
    const img = variantImg || p.images?.[0]?.src || p.image?.src || '';
    const displayTitle = getVariantModelLabel(p, sv) || p.title;
    const variantValues = sv && sv.title && sv.title !== 'Default Title'
      ? sv.title.split('/').map((value) => value.trim()).filter(Boolean)
      : [];
    $(`[data-slot-title="${idx}"]`).textContent = displayTitle;
    const variantEl = $(`[data-slot-variants="${idx}"]`);
    if (variantEl) {
      variantEl.innerHTML = variantValues
        .map((value) => `<span class="pc-product-card__variant-badge">${value}</span>`)
        .join('');
    }
    const imgEl = $(`[data-slot-img="${idx}"]`);
    imgEl.src = imgSrc(img, '400x400');
    imgEl.alt = displayTitle;
    $(`[data-slot-price="${idx}"]`).textContent = money(sv?.price || p.variants?.[0]?.price);
    const urlEl = $(`[data-slot-url="${idx}"]`);
    urlEl.href = sv
      ? `${CFG.shopUrl}/products/${p.handle}?variant=${sv.id}`
      : `${CFG.shopUrl}/products/${p.handle}`;

    $(`[data-slot-card="${idx}"]`).style.display = '';
    $(`[data-slot-empty="${idx}"]`).style.display = 'none';
  }

  function refreshSlotCards() {
    getSlotIndexes().forEach((i) => {
      if (S.slots[i]) refreshSlotCard(i);
    });
  }

  /* ── 下拉对比表格 ── */
  function refreshSlotTable() {
    updateBrowseAddControl();
    const filled = getSlotIndexes().filter((i) => S.slots[i]);
    const tableWrap = $('[data-slot-table]');
    const emptyHint = $('[data-slot-empty-hint]');
    if (!filled.length) {
      tableWrap.style.display = 'none';
      if (emptyHint) emptyHint.style.display = '';
      return;
    }
    tableWrap.style.display = '';
    if (emptyHint) emptyHint.style.display = 'none';
    const products = filled.map((i) => S.slots[i]);
    const variantIds = filled.map((i) => {
      const sv = (S.slotVariant || {})[i];
      return sv ? String(sv.id) : null;
    });
    renderSpecTable(products, '[data-slot-thead]', '[data-slot-tbody]', variantIds);
    initDiffToggle('[data-slot-toggle-diff]', '[data-slot-tbody]');
  }

  /* ============================================================
     共享：参数表格渲染
     ============================================================ */
  /**
   * 渲染规格对比表格
   * 优先从 metafield 动态提取所有 spec key，如果 metafield 无数据则回退到 specGroups 手动配置
   */
  function renderSpecTable(products, theadSel, tbodySel, variantIds) {
    const thead = $(theadSel);
    const tbody = $(tbodySel);
    const na = CFG.labels?.na || '-';
    const colSpan = products.length + 1;
    const table = thead.closest('table');
    if (table) table.style.minWidth = `${Math.max(720, (products.length + 1) * 150)}px`;
    const dragHandle = '<span class="pc-drag-handle" draggable="true" title="Drag to reorder">⠿</span>';
    const compareTitle = (product, index) => {
      const vid = variantIds?.[index];
      const variant = vid ? (product.variants || []).find((v) => String(v.id) === vid) : null;
      const variantValues = variant && variant.title && variant.title !== 'Default Title'
        ? variant.title.split('/').map((value) => value.trim()).filter(Boolean)
        : [];
      const variantBadges = variantValues.length
        ? `<div class="pc-compare-table__variants">${variantValues
          .map((value) => `<span class="pc-product-card__variant-badge">${value}</span>`)
          .join('')}</div>`
        : '';
      return `<span class="pc-compare-table__product-title">${product.title}</span>${variantBadges}`;
    };

    thead.innerHTML =
      '<th>Product Name</th>' +
      products.map((p, i) => `<th>${compareTitle(p, i)}</th>`).join('');

    let rows = '';
    rows += `<tr data-spec-key="__price" data-no-drag>`;
    rows += `<td><strong>Price</strong></td>`;
    products.forEach((p, i) => {
      const vid = variantIds?.[i];
      const variant = vid
        ? (p.variants || []).find((v) => String(v.id) === vid)
        : p.variants?.[0];
      rows += `<td>${money(variant?.price || p.variants?.[0]?.price)}</td>`;
    });
    rows += '</tr>';

    const autoKeys = collectSpecKeys(products, variantIds);

    if (autoKeys.length) {
      rows += `<tr class="pc-group-row"><td colspan="${colSpan}">Specifications</td></tr>`;
      autoKeys.forEach((spec) => {
        rows += `<tr data-spec-key="${spec.key}">`;
        rows += `<td>${dragHandle}<strong>${spec.label}</strong></td>`;
        products.forEach((p, i) => {
          const vid = variantIds?.[i];
          const val = tagVal(p, spec.key, vid);
          rows += `<td>${val || na}</td>`;
        });
        rows += '</tr>';
      });
    } else {
      const groups = (CFG.specGroups || []).filter(
        (g) => (g.category || '').toLowerCase().trim() === S.category.toLowerCase().trim()
      );
      groups.forEach((g) => {
        rows += `<tr class="pc-group-row"><td colspan="${colSpan}">${g.name}</td></tr>`;
        (g.specs || []).forEach((spec) => {
          rows += `<tr data-spec-key="${spec.key}">`;
          rows += `<td>${dragHandle}<strong>${spec.label}</strong></td>`;
          products.forEach((p, i) => {
            const vid = variantIds?.[i];
            const val = tagVal(p, spec.key, vid);
            rows += `<td>${val || na}</td>`;
          });
          rows += '</tr>';
        });
      });
    }

    tbody.innerHTML = rows;
    initRowDrag(tbody);
    buildSpecTogglePanel(tbody);
  }

  /* ============================================================
     行拖拽排序（原生 Drag & Drop）
     ============================================================ */
  function initRowDrag(tbody) {
    let dragRow = null;

    tbody.addEventListener('dragstart', (e) => {
      const handle = e.target.closest('.pc-drag-handle');
      if (!handle) { e.preventDefault(); return; }
      dragRow = handle.closest('tr');
      if (!dragRow || dragRow.classList.contains('pc-group-row')) { e.preventDefault(); return; }
      dragRow.classList.add('is-dragging');
      e.dataTransfer.effectAllowed = 'move';
    });

    tbody.addEventListener('dragover', (e) => {
      e.preventDefault();
      e.dataTransfer.dropEffect = 'move';
      const target = e.target.closest('tr');
      if (!target || target === dragRow || target.classList.contains('pc-group-row') || target.hasAttribute('data-no-drag')) return;
      const rect = target.getBoundingClientRect();
      const mid = rect.top + rect.height / 2;
      if (e.clientY < mid) {
        tbody.insertBefore(dragRow, target);
      } else {
        tbody.insertBefore(dragRow, target.nextSibling);
      }
    });

    tbody.addEventListener('dragend', () => {
      if (dragRow) dragRow.classList.remove('is-dragging');
      dragRow = null;
    });
  }

  /* ============================================================
     参数显示/隐藏 勾选面板
     ============================================================ */
  function buildSpecTogglePanel(tbody) {
    const tableWrap = tbody.closest('.pc-table-wrap');
    if (!tableWrap) return;
    let panel = tableWrap.querySelector('.pc-spec-toggle');
    if (panel) panel.remove();

    const specRows = $$('tr[data-spec-key]', tbody);
    if (!specRows.length) return;

    panel = document.createElement('div');
    panel.className = 'pc-spec-toggle';

    let html = '<button type="button" class="pc-spec-toggle__trigger" data-spec-toggle-btn>'
      + '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M1.5 7.5L5.5 11.5L12.5 3.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'
      + ' Manage Columns</button>';
    html += '<div class="pc-spec-toggle__list" data-spec-toggle-list style="display:none">';
    specRows.forEach((tr) => {
      const key = tr.dataset.specKey;
      const label = tr.querySelector('td strong')?.textContent || key;
      html += `<label class="pc-spec-toggle__item"><input type="checkbox" checked data-spec-check="${key}"><span>${label}</span></label>`;
    });
    html += '</div>';
    panel.innerHTML = html;

    const actions = tableWrap.querySelector('.pc-table-actions');
    if (actions) {
      actions.appendChild(panel);
    } else {
      tableWrap.insertBefore(panel, tableWrap.querySelector('.pc-table'));
    }

    const triggerBtn = panel.querySelector('[data-spec-toggle-btn]');
    const list = panel.querySelector('[data-spec-toggle-list]');
    triggerBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      const open = list.style.display === 'none';
      list.style.display = open ? '' : 'none';
      triggerBtn.classList.toggle('is-active', open);
    });

    document.addEventListener('click', (e) => {
      if (!panel.contains(e.target)) {
        list.style.display = 'none';
        triggerBtn.classList.remove('is-active');
      }
    });

    $$('[data-spec-check]', panel).forEach((cb) => {
      cb.addEventListener('change', () => {
        const key = cb.dataset.specCheck;
        const row = tbody.querySelector(`tr[data-spec-key="${key}"]`);
        if (row) row.style.display = cb.checked ? '' : 'none';
      });
    });
  }

  function initDiffToggle(btnSel, tbodySel) {
    const btn = $(btnSel);
    const tbody = $(tbodySel);
    if (!btn || !tbody) return;
    if (btn.dataset.diffInitialized !== 'true') {
      btn.classList.add('is-active');
      btn.dataset.diffInitialized = 'true';
    }
    highlightDiff(tbody, btn.classList.contains('is-active'));
    btn.onclick = () => {
      const active = btn.classList.toggle('is-active');
      highlightDiff(tbody, active);
    };
  }

  function highlightDiff(tbody, on) {
    const normalize = (s) => s.trim().toLowerCase().replace(/\s+/g, ' ');
    const rows = $$('tr', tbody);
    rows.forEach((tr) => {
      if (tr.classList.contains('pc-group-row')) return;
      const cells = $$('td', tr).slice(1);
      cells.forEach((c) => c.classList.remove('is-diff'));
      if (!on || cells.length < 2) return;
      const vals = cells.map((c) => normalize(c.textContent));
      const allSame = vals.every((v) => v === vals[0]);
      if (!allSame) cells.forEach((c) => c.classList.add('is-diff'));
    });
  }

  /**
   * 颜色名称转 hex
   * 先精确匹配完整名称，再尝试包含关键词匹配，最后 fallback
   */
  function colorNameToHex(name) {
    const exact = {
      'black': '#1a1a1a', 'white': '#f0f0f0', 'silver': '#c0c0c0',
      'gray': '#808080', 'grey': '#808080', 'red': '#e53935',
      'blue': '#1e88e5', 'green': '#43a047', 'pink': '#f06292',
      'purple': '#8e24aa', 'orange': '#fb8c00', 'yellow': '#fdd835',
      'navy': '#283593', 'brown': '#6d4c41', 'gold': '#ffc107',
      'carbon': '#333333', 'midnight': '#191970', 'champagne': '#f7e7ce',
      'sunset orange': '#ff6f3c', 'shadow white': '#d8d8d8',
      'metallic red': '#c62828', 'metallic silver': '#b0b0b0',
      'metallic purple': '#7b1fa2', 'pearl blue': '#64b5f6',
      'coral pink': '#f48fb1', 'ice blue': '#81d4fa',
      'crystal purple': '#ce93d8', 'sakura pink': '#f8bbd0',
      'gunmetal gray': '#5c5c5c', 'gunmetal grey': '#5c5c5c',
      'space gray': '#3a3a3c', 'space grey': '#3a3a3c',
      'rose gold': '#e8b4b8', 'mint green': '#a5d6a7',
      'leviatan collab': '#1a1a1a', 'leviatan collaboration': '#1a1a1a',
      'white?': '#f0f0f0', 'black?': '#1a1a1a',
    };
    const lower = name.toLowerCase().trim();
    if (exact[lower]) return exact[lower];

    /* 关键词 fallback：从名称中提取基础颜色 */
    const keywords = [
      ['black', '#1a1a1a'], ['white', '#f0f0f0'], ['red', '#e53935'],
      ['blue', '#1e88e5'], ['pink', '#f06292'], ['purple', '#8e24aa'],
      ['orange', '#fb8c00'], ['green', '#43a047'], ['silver', '#b0b0b0'],
      ['gold', '#ffc107'], ['gray', '#808080'], ['grey', '#808080'],
      ['yellow', '#fdd835'], ['brown', '#6d4c41'],
    ];
    for (const [kw, hex] of keywords) {
      if (lower.includes(kw)) return hex;
    }
    return '#ccc';
  }

  /* ── 启动 ── */
  function boot() {
    if (!document.querySelector('[data-compare-config]')) return;
    init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /**
   * 主题编辑器会动态重新渲染 section，需要重新绑定事件
   * Shopify 在编辑器中触发 shopify:section:load 事件
   */
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target?.classList?.contains('shopify-section--product-compare')) {
      Object.keys(fetchCache).forEach((k) => delete fetchCache[k]);
      S.products = {};
      S.seriesMap = {};
      boot();
    }
  });
})();
